module.exports = __webpack_public_path__ + "img/campaigns.756c115b.svg";